export const ObjectTypeSelector = ( { allObjectTypes, searchOnClick } ) => {
	// A filter is applied so you can re-order the object types, or remove some. By default remove remove product_variation (since those are shown under
	// Products anyway)
	const filteredObjectTypes = wp.hooks.applyFilters(
		'qalaElasticCore.filter.objectTypeSelector.allObjectTypes',
		allObjectTypes
			.filter( objectType => {
				return objectType?.name && objectType.name !== 'product_variation';
			} )
	);

	return (
		<div className="qec-results__object-type-selector">
			{ filteredObjectTypes.map( singleObjectType => {
				const classes = [ 'btn' ];
				if ( ! singleObjectType.isActive ) {
					classes.push( 'btn-type-3' );
				}
				return (
					<button
						className={ classes.join( ' ' ) }
						key={ singleObjectType.name }
						onClick={ () => searchOnClick( singleObjectType.name ) }
					>
						{ singleObjectType.namePretty || singleObjectType.name } ({ singleObjectType.count })
					</button>
				);
			} ) }
		</div>
	);
};
